import type { SyntheticEvent } from 'react'
import { Badge, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@teach/ui'
import { Info } from 'lucide-react'
import { useMessages } from '@/i18n'
import { messages } from './messages'
import { messages as settingsMessages } from '../course-settings/messages'

interface Props {
  /** Гасит выбор языка и закрытие меню по клику на «i» (владелец — `LangMenuItem`). */
  stopMenu: {
    onPointerDown: (e: SyntheticEvent) => void
    onPointerUp: (e: SyntheticEvent) => void
    onClick: (e: SyntheticEvent) => void
    onKeyDown: (e: SyntheticEvent) => void
  }
}

/** Бейдж «Базовый» с подсказкой, что это значит, — у базового языка в меню шапки. */
export const BaseLangBadge = ({ stopMenu }: Props) => {
  const m = useMessages(messages)
  const hint = useMessages(settingsMessages).baseLangHint
  return (
    <Badge variant="neutral" className="gap-1 bg-brand text-brand-foreground">
      {m.baseBadge}
      <TooltipProvider delayDuration={150}>
        <Tooltip>
          <TooltipTrigger asChild>
            <span {...stopMenu} aria-label={m.whatIsBase} className="flex hover:opacity-80">
              <Info className="size-3" />
            </span>
          </TooltipTrigger>
          <TooltipContent side="left" className="max-w-56">
            {hint}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </Badge>
  )
}
